import script from "./GgmsDisclosureForNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsDisclosureForNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsDisclosureForNavigation.vue?vue&type=style&index=0&id=3e2d1b96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2d1b96"]])

export default __exports__